import Cookies from 'js-cookie';
import { findIndex, drop } from 'lodash';
import { HintMessages } from '../../../Enums';
import {
  NEXT_HINT_MESSAGE,
  PREV_HINT_MESSAGE,
  SET_DISABLE_HINT_MESSAGES,
  SHOW_TWO_SEGMENTS_DIALOG,
  TWO_SEGMENTS_DIALOG_SHOWN,
} from './Actions';
import { SET_VISIBLE } from '@configuratorware/configurator-frontendgui/App/Reducers/UI/Actions';
import { actionTypes as DesignDataActionTypes } from '@configuratorware/configurator-frontendgui/App/Reducers/DesignData/Actions';
import { actionTypes as DesignAreaActionTypes } from '@configuratorware/configurator-frontendgui/App/Reducers/DesignArea/Actions';
import { Services } from '@configuratorware/configurator-frontendgui/App/ServiceLocator';
import { hasHintMessage } from './Selectors';

const orderedHintMessages = [
  HintMessages.EditDesignButton,
  HintMessages.DesignAreaSelect,
  HintMessages.DesignProductionMethodSelect,
  HintMessages.AddVisualElementButton,
  HintMessages.EditVisualElement,
  HintMessages.SaveAndDownloadConfigurationButton,
  HintMessages.AddToCartButton,
];

const initialState = {
  hintMessages: orderedHintMessages,
  activeHintMessage: orderedHintMessages[0],
  disableHintMessages: Cookies.get('disable_hint_messages') || false,
  hasUpdatedCanvas: false,
  twoSegmentsDialogShown: false,
  showTwoSegmentsDialog: false,
};

export function hintMessagesReducer(state = initialState, action = {}) {
  switch (action.type) {
    case NEXT_HINT_MESSAGE: {
      const currentHintMessageIndex = findIndex(state.hintMessages, (msg) => msg === state.activeHintMessage);
      return {
        ...state,
        activeHintMessage: state.hintMessages[currentHintMessageIndex + 1],
      };
    }
    case PREV_HINT_MESSAGE: {
      const currentHintMessageIndex = findIndex(state.hintMessages, (msg) => msg === state.activeHintMessage);
      return {
        ...state,
        activeHintMessage: state.hintMessages[currentHintMessageIndex - 1],
      };
    }
    case SET_DISABLE_HINT_MESSAGES: {
      return {
        ...state,
        disableHintMessages: true,
      };
    }
    case SET_VISIBLE: {
      if (action.name === 'designer' && action.show) {
        return {
          ...state,
          activeHintMessage: hasHintMessage(state.hintMessages, HintMessages.DesignAreaSelect)
            ? HintMessages.DesignAreaSelect
            : null,
        };
      } else if (action.name === 'imageEditDialog' && action.show) {
        const currentHintMessageIndex = findIndex(
          state.hintMessages,
          (msg) => msg === HintMessages.AddVisualElementButton
        );
        return {
          ...state,
          hintMessages: drop(state.hintMessages, currentHintMessageIndex + 1),
          activeHintMessage: null,
        };
      }
      return state;
    }
    case DesignAreaActionTypes.SELECT_DESIGN_AREA: {
      return {
        ...state,
        activeHintMessage: hasHintMessage(state.hintMessages, HintMessages.DesignAreaSelect)
          ? HintMessages.DesignAreaSelect
          : null,
      };
    }
    case DesignDataActionTypes.SET_CANVAS_DATA: {
      const designArea = Services.visualization.getActiveDesignArea();
      const canvas = Services.designData._getCanvas(designArea);
      const currentHintMessageIndex = findIndex(
        state.hintMessages,
        (msg) => msg === HintMessages.AddVisualElementButton
      );
      return {
        ...state,
        hintMessages: drop(state.hintMessages, currentHintMessageIndex + 1),
        activeHintMessage: canvas.selectedObject
          ? hasHintMessage(state.hintMessages, HintMessages.EditVisualElement)
            ? HintMessages.EditVisualElement
            : null
          : hasHintMessage(state.hintMessages, HintMessages.SaveAndDownloadConfigurationButton)
          ? HintMessages.SaveAndDownloadConfigurationButton
          : null,
        hasUpdatedCanvas: action.canvasData.objects.length > 0,
      };
    }
    case DesignAreaActionTypes.CLEAR_DESIGN_AREA_SELECTION: {
      return {
        ...state,
        activeHintMessage: state.hasUpdatedCanvas
          ? hasHintMessage(state.hintMessages, HintMessages.SaveAndDownloadConfigurationButton)
            ? HintMessages.SaveAndDownloadConfigurationButton
            : null
          : hasHintMessage(state.hintMessages, HintMessages.EditDesignButton)
          ? HintMessages.EditDesignButton
          : null,
        hasUpdatedCanvas: false,
      };
    }
    case 'POST_DATA': {
      if (action.source === 'configuration/validate') {
        return {
          ...state,
          activeHintMessage: null,
          hintMessages: [],
        };
      }
      return state;
    }
    case SHOW_TWO_SEGMENTS_DIALOG: {
      return {
        ...state,
        showTwoSegmentsDialog: true,
      };
    }
    case TWO_SEGMENTS_DIALOG_SHOWN: {
      return {
        ...state,
        twoSegmentsDialogShown: true,
        showTwoSegmentsDialog: false,
      };
    }
    default:
      return state;
  }
}

export default hintMessagesReducer;
